import { filter, get, head, isEmpty, map } from 'lodash/fp';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';

import { CONTENT_SECTIONS } from '../../../content/sections';
import type { SellingPoint, SellingPointGroup } from '../../../../../types/sanity';

const mapSellingPointsContent = ({ refersToContent }: any) => {
  const sellingPointGroups = filter(
    (section) => get('__typename', section) === CONTENT_SECTIONS.SELLING_POINTS_GROUP,
    refersToContent,
  ) as SellingPointGroup[];

  if (isEmpty(sellingPointGroups)) {
    return null;
  }

  let cta;
  let title;
  let groups;

  if (sellingPointGroups.length > 1) {
    title = 'Find private health cover to suit your needs';
    groups = map(
      (sellingPointGroup: SellingPointGroup) => ({
        contentTitle: sellingPointGroup.name,
        cta: {
          name: sellingPointGroup.cta?.name,
          url: sellingPointGroup.cta?.url,
        },
        description: sellingPointGroup.summary,
        sellingPoints: map(
          (sellingPoint: SellingPoint) => ({
            description: sellingPoint.summary,
            title: sellingPoint.name,
          }),
          sellingPointGroup.sellingPointGroup,
        ),
        tabTitle: sellingPointGroup.name,
      }),
      sellingPointGroups,
    );
  }

  if (sellingPointGroups.length === 1) {
    const [group] = sellingPointGroups as [SellingPointGroup];
    cta = group.cta;
    title = portableTextToPlain(group.slogan) || group.name;
    groups = [
      {
        description: group.summary,
        sellingPoints: map(
          (point: SellingPoint) => ({
            description: point.summary,
            title: point.name,
          }),
          group.sellingPointGroup,
        ),
      },
    ];
  }

  const mappedCmsContent = {
    cta,
    groups,
    orderIndex: get('orderIndex', head(sellingPointGroups)),
    title,
    type: CONTENT_SECTIONS.SELLING_POINTS_GROUP,
  };

  return mappedCmsContent;
};

export default mapSellingPointsContent;
